module.exports = __webpack_public_path__ + "static/img/20008 (1).ec6f990.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20008 (1).webp
// module id = LJV/
// module chunks = 14